<template>
  <AppShell title="Räntor">
    <div class="flex flex-col gap-8">
      <RatesTable
        title="Aktuella och historiska listräntor"
        :rates="currentAndHistoricRates"
        empty-text="Inga räntor hittades"
      />
      <template v-if="isPricingAdmin">
        <RatesTable title="Kommande listräntor" :rates="upcomingRates" empty-text="Inga kommande listräntor" />
        <PricingManagerSection />
        <RateAuditTrailTable />
      </template>
    </div>
  </AppShell>
</template>

<script setup lang="ts">
import { computed, onMounted } from 'vue'
import AppShell from '@/components/AppShell.vue'
import { hasRequiredScope } from '@/services/auth'
import { usePricing } from '@/composables/usePricing'

import RatesTable from './RatesTable.vue'
import RateAuditTrailTable from './RateAuditTrailTable.vue'
import PricingManagerSection from './PricingManagerSection.vue'

// Aktuella och historiska listräntor kräver bara `broker`; allt annat på sidan kräver brokerPricingAdministrator.
const isPricingAdmin = computed(() => hasRequiredScope('brokerPricingAdministrator'))

const { currentAndHistoricRates, upcomingRates, fetchRates } = usePricing()

onMounted(() => {
  fetchRates()
})
</script>
